// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2ly8c","col":"styles_col__3LJVy"};